import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';
import EntitySearch from 'components/@common/EntitySearch';
import { ReportEntityType, ReportProduct } from '../../../../types';
import { useField } from 'formik';
import { ENTITY_SEARCH_LIMIT, ENTITY_TYPE_OPTIONS_MAP } from '../../../../utils/report-param-utils';
import useSearchableOptions from './use-searchable-options';

type Props = {
  name?: string;
  entityType: ReportEntityType;
  productFamilyCode: ReportProduct;
} & Partial<React.ComponentProps<typeof EntitySearch>>;

const EntitySearchField: React.FC<Props> = ({
  name = 'entityId',
  entityType,
  productFamilyCode,
  ...props
}) => {
  const { t } = useTranslation('Reports');
  const [field, meta] = useField(name);
  const [
    { options, selectedItem, loading },
    { handleSearch, handleChangeEntity }
  ] = useSearchableOptions({
    name,
    entityType,
    productFamilyCode
  });
  const { getOptionLabel } = ENTITY_TYPE_OPTIONS_MAP[entityType];

  return (
    <EntitySearch
      value={selectedItem}
      {...props}
      renderInput={(inputProps): React.ReactNode => (
        <TextField
          {...inputProps}
          {...field}
          label="Select Entity"
          variant="outlined"
          size="small"
          placeholder={`${t('Type to search')}...`}
          fullWidth
          error={!!meta.error && meta.touched}
        />
      )}
      onChange={handleChangeEntity}
      onInputChange={(e, value, reason): any => reason === 'input' && handleSearch(e, value)}
      onOpen={(e): void => handleSearch(e, '')}
      getOptionLabel={getOptionLabel}
      limit={ENTITY_SEARCH_LIMIT}
      resultsText={t('Showing first {{limit}} results', { limit: ENTITY_SEARCH_LIMIT })}
      noOptionsText={t('No {{entityName}} entities found', { entityName: t(entityType) })}
      loading={loading}
      options={options}
      multiple={false}
    />
  );
};

export default EntitySearchField;
